/**
 * @generated SignedSource<<d43294402b898c3229e7aba801086cef>>
 * @relayHash 3b2300539134eec5a57f18f298c307e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec

import type { ConcreteRequest } from 'relay-runtime';
export type useEmbeddedMigrationQueryEmbeddedWithMigrationQuery$variables = {
  contentId: string;
};
export type useEmbeddedMigrationQueryEmbeddedWithMigrationQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly embeddedWithMigration: boolean;
        } | null;
      };
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type useEmbeddedMigrationQueryEmbeddedWithMigrationQuery = {
  response: useEmbeddedMigrationQueryEmbeddedWithMigrationQuery$data;
  variables: useEmbeddedMigrationQueryEmbeddedWithMigrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "embeddedWithMigration"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b2300539134eec5a57f18f298c307e4",
    "id": "3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec",
    "metadata": {},
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
    "operationKind": "query",
    "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
  }
};
})();

(node as any).hash = "226895c47be9fed079eb4901c8267e39";

export default node;
